import React from "react";
import logger from "logger";
import { getStyleJSON, TROOP_NAMES } from "Utils/Common";
import AngSelect from "Common/Angular/AngSelect";
import TaskInput from "TaskDialogCommon/TaskInput";
import { DialogButton } from "Common/DialogButton";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import IconButton from "@material-ui/core/IconButton";
import EdiText from "react-editext";
import "./index.css";

export default function(props) {
  const { label, taskConfig, param, setValue } = props;
  const troopNamesForThisrace = {};
  const [selectedtroopkiller, setselectedtroopkiller] = React.useState("");
  const [
    selectedtroopquantitykiller,
    setselectedtroopquantitykiller,
  ] = React.useState("");

  const valueobj = taskConfig[param];

  for (var prop in TROOP_NAMES) {
    if (TROOP_NAMES.hasOwnProperty(prop)) {
      if (prop.indexOf("u") === 0) {
        troopNamesForThisrace[prop] = TROOP_NAMES[prop];
      }
    }
  }

  const handleSave = (selectedtroop, value) => {
    const troopobject = { ...valueobj };
    troopobject[selectedtroop] = value;
    setValue(
      {
        target: {
          value: troopobject,
        },
      },
      param
    );
  };

  const deleteSelectedTroop = (selectedtroop) => {
    const troopobject = { ...valueobj };
    delete troopobject[selectedtroop];
    setValue(
      {
        target: {
          value: troopobject,
        },
      },
      param
    );
  };

  const addSelectedTroop = (selectedtroop, selectedquantity) => {
    if (!selectedtroop) {
      alert("Select a troop type first.");
      return;
    }
    if (!selectedquantity) {
      alert("Set a troop quantity.");
      return;
    }
    const troopobject = { ...valueobj };
    var currentValue = troopobject[selectedtroop];
    if (currentValue === null || currentValue === undefined) {
      troopobject[selectedtroop] = selectedquantity;
    } else {
      var a = Number(currentValue || 0);
      var b = Number(selectedquantity || 0);
      troopobject[selectedtroop] = a + b;
    }
    setValue(
      {
        target: {
          value: troopobject,
        },
      },
      param
    );
    setselectedtroopkiller("");
    setselectedtroopquantitykiller("");
  };

  const clearSelection = () => {
    setValue(
      {
        target: {
          value: {},
        },
      },
      param
    );
  };

  return (
    <>
      <div style={{ float: "left" }}>{label}</div>
      <div
        style={getStyleJSON("display:inline-flex;margin-top:10px;")}
        className="fullWidth"
      >
        <div style={{ flex: "1" }}>
          <AngSelect
            ng-model={selectedtroopkiller}
            styleStr="margin: 0 auto;"
            options={
              troopNamesForThisrace
                ? Object.keys(troopNamesForThisrace).map((key) => {
                    const value = troopNamesForThisrace[key];
                    return {
                      label: value,
                      value: key,
                    };
                  })
                : []
            }
            onChange={(selectedValue) => {
              logger.log("selected Value", selectedValue);
              setselectedtroopkiller(selectedValue.value);
            }}
          />
        </div>
        <div
          style={getStyleJSON(
            "margin-left: 10px; padding-right: 0px;display: flex;justify-content: center;align-items: center;"
          )}
        >
          <TaskInput
            placeholder="Quantity"
            value={selectedtroopquantitykiller}
            onChange={({ target: { value } }) => {
              setselectedtroopquantitykiller(value);
            }}
            type="number"
          />
        </div>
      </div>
      <div
        style={getStyleJSON(
          "margin-top:10px;display: flex;justify-content: center;"
        )}
      >
        <DialogButton
          label="Add Troop"
          style={getStyleJSON("font-weight: bold; font-size: 15px")}
          onClick={() => {
            addSelectedTroop(selectedtroopkiller, selectedtroopquantitykiller);
          }}
        />
        <DialogButton
          label="Clear Troops"
          style={getStyleJSON("font-weight: bold; font-size: 15px")}
          onClick={() => {
            clearSelection(taskConfig.troopskiller);
          }}
        />
      </div>
      <div style={{ marginTop: "10px", padding: "7px" }}>
        {taskConfig[param] &&
          Object.keys(taskConfig[param]).map((key) => {
            const value = taskConfig[param][key];

            return (
              <div style={{ display: "flex" }}>
                <TroopCountSelected
                  label={troopNamesForThisrace[key]}
                  value={value}
                  onSave={(val) => {
                    handleSave(key, val);
                  }}
                  onDelete={() => deleteSelectedTroop(key)}
                />
              </div>
            );
          })}
      </div>
    </>
  );
}

const TroopCountSelected = ({ label, value, onSave, onDelete }) => {
  const [deleteVisible, setDeleteVisible] = React.useState(true);

  return (
    <>
      {deleteVisible && (
        <div
          style={{
            //marginLeft: "20px",
            paddingRight: "0px",
            //flex: "1",
            textAlign: "left",
            //border: "1px solid",
            width: "50%",
            display: "table",
            padding: "15px",
          }}
        >
          <span id="content">{label}</span>
        </div>
      )}
      <div
        style={{
          //marginLeft: "20px",
          //marginRight: "20px",
          //border: "1px solid",
          width: `${deleteVisible ? "50%" : "100%"}`,
          textAlign: "right",
          display: "flex",
        }}
      >
        <span style={{ marginLeft: "auto" }}>
          <EdiText
            type="text"
            value={value}
            onSave={(val) => {
              onSave(val);
              setDeleteVisible(true);
            }}
            onEditingStart={() => {
              setDeleteVisible(false);
            }}
            onCancel={() => {
              setDeleteVisible(true);
            }}
          />
        </span>
        {deleteVisible && (
          <IconButton
            color="#000000"
            component="span"
            onClick={() => onDelete()}
            size={"small"}
          >
            <HighlightOffIcon />
          </IconButton>
        )}
      </div>
    </>
  );
};
